import { selectEditFieldData } from 'app/containers/Field/slice/selectors';
import { useMapSlice } from 'app/containers/Map/slice';
import { selectIsMapReady } from 'app/containers/Map/slice/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface IProps {
  fieldIdInParams: string;
}

const useZoomOnFieldOnMapLoad = ({ fieldIdInParams }: IProps) => {
  const dispatch = useDispatch();
  const mapActions = useMapSlice().actions;

  const isMapReady = useSelector(selectIsMapReady);

  const { fieldId } = useSelector(selectEditFieldData);

  useEffect(() => {
    if (fieldId === Number(fieldIdInParams) && isMapReady) {
      dispatch(mapActions.zoomSingleFieldMap());
    }
  }, [dispatch, mapActions, fieldId, isMapReady, fieldIdInParams]);

  return null;
};

export default useZoomOnFieldOnMapLoad;
